/**
 * Local Development Quick Login
 *
 * On localhost, shows quick-login buttons for pre-configured Auth0 test users.
 * These buttons trigger real Auth0 authentication (no bypass).
 * On deployed environments, this is not used.
 */

/**
 * Whether the app is running on localhost (local dev environment).
 */
export const isLocalDev =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

/**
 * Whether the app is running in a non-production environment (local, dev, or staging).
 * Used to show quick-login buttons — NOT to bypass auth.
 * The backend ROPG proxy (/api/auth/dev-login) must also have APP_MODE=dev.
 */
export const isDevEnvironment =
    isLocalDev ||
    (typeof window !== 'undefined' &&
        (window.location.hostname.startsWith('dev.') ||
         window.location.hostname.startsWith('staging.')))

/**
 * Test users available for quick login on localhost.
 * These are real Auth0 users created in the channelstandard tenant.
 * All use the same password for convenience.
 */
export const TEST_USERS = [
    {
        email: 'admin@channelstandard.dev',
        name: 'Admin User',
        role: 'ADMIN',
    },
    {
        email: 'advisor.pro@example.com',
        name: 'Professional Advisor',
        role: 'ADVISOR',
    },
    {
        email: 'advisor.free@example.com',
        name: 'Free Tier Advisor',
        role: 'ADVISOR',
    },
    {
        email: 'admin@acme-telecom.com',
        name: 'ACME Admin',
        role: 'SUPPLIER_ADMIN',
    },
    {
        email: 'admin@cloudconnect.io',
        name: 'CloudConnect Admin',
        role: 'SUPPLIER_ADMIN',
    },
] as const

export type TestUser = (typeof TEST_USERS)[number]
